import { updateObject } from "../../../../shared";
import { globalConstants, brandPerformanceConstants } from "../../constants";

const { SUCCESS, FAILURE } = globalConstants;
const {
  ALL_GROUP_RESPONSE_DATA,
  ALL_RESTAURANT_RESPONSE_DATA,
  CUSTOMER_RESPONSES_EXPORT_ALL_DATA,
  GROUPS_AVERAGE_SENTIMENT_AND_TRANSACTION_RATING,
  STORES_AVERAGE_SENTIMENT_AND_TRANSACTION_RATING,
} = brandPerformanceConstants;

const initialState = {
  allItemsForExport: [],
  franchiseResponsesData: [],
  restaurantResponsesData: [],
  allFranchiseResponsesData: [],
  allRestaurantResponsesData: [],
  restaurantResponseDataPagination: {
    size: 10,
    number: 0,
    totalElements: 0,
  },
  groupResponseDataPagination: {
    size: 10,
    number: 0,
    totalElements: 0,
  },
  groupsAvgSentimentAndTransactionRatingData: {},
  storesAvgSentimentAndTransactionRatingData: {},
};

export const brandPerformanceReducer = (state = initialState, action) => {
  switch (action.type) {
    case ALL_RESTAURANT_RESPONSE_DATA + SUCCESS:
      return updateObject(state, {
        allRestaurantResponsesData: action.data.pageData,
        restaurantResponsesData: action.data.pageData.result,
        restaurantResponseDataPagination: action.data.page,
      });
    case ALL_GROUP_RESPONSE_DATA + SUCCESS:
      return updateObject(state, {
        allFranchiseResponsesData: action.data.pageData,
        franchiseResponsesData: action.data.pageData.result,
        groupResponseDataPagination: action.data.page,
      });
    case CUSTOMER_RESPONSES_EXPORT_ALL_DATA + SUCCESS:
      return updateObject(state, {
        allItemsForExport: action.data,
      });
    case CUSTOMER_RESPONSES_EXPORT_ALL_DATA + FAILURE:
      return updateObject(state, { allItemsForExport: [] });
    case GROUPS_AVERAGE_SENTIMENT_AND_TRANSACTION_RATING + SUCCESS:
      return updateObject(state, {
        groupsAvgSentimentAndTransactionRatingData: action.data,
      });
    case STORES_AVERAGE_SENTIMENT_AND_TRANSACTION_RATING + SUCCESS:
      return updateObject(state, {
        storesAvgSentimentAndTransactionRatingData: action.data,
      });
    default:
      return state;
  }
};
